/* tslint:disable:indent */
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import { StepperBuilderService } from '../../../../avisDePub/creer/services/stepper.builder.service';
import {ErreurMessages} from '../../../models/component-messages/erreur-messages';
import {LogService} from '../../../services/log.service';
import {FormInputErrorTools} from './utils/form-input-error.tools';
import { Field } from '../../../../formulaires/eforms/model/field';

@Component({
  selector: 'app-form-input-error',
  templateUrl: './form-input-error.component.html',
  styleUrls: ['./form-input-error.component.scss']
})
export class FormInputErrorComponent implements OnInit, OnDestroy {

  private LOG: LogService = new LogService(FormInputErrorComponent);

  private readonly _submitted = 'submitted';

  @Input() activeForm: FormGroup;
  @Input() type: string;
  @Input() name: string;
  @Input() errorMessage: any;
  @Input() rule: string;
  @Input() eform = false;
  @Input() pathElements = [];
  @Input() repeatablePathWithIndex = '';
  @Input() arrayLength = 0;
  @Input() lastElementArray = null;
  @Input() localformGroup;
  @Input() index: string;
  @Input() field: Field;

  public controlName: AbstractControl;
  public erreurMessages = new ErreurMessages();

  constructor(private stepperBuilderService: StepperBuilderService) {
  }

  ngOnDestroy(): void {
    if (this.name) {
      // TODO : MERGE-FACT : désactiver ce bloc afin d'analyser le pb
      this.activeForm.removeControl(this.name);
    }
  }

  public ngOnInit() {
    if (this.eform) {
      this.controlName=this.localformGroup.controls[this.name];
    } else {
      this.controlName = this.activeForm.controls[this.name];
    }
  }


  public hasError(): boolean {
    if (this.eform) {
      const onSubmit = this.activeForm.controls[this._submitted]?.value;
      const hasError = FormInputErrorTools.hasError(this.controlName, this.name, onSubmit, true);
      const hasErrorPatternOrMaxLength = FormInputErrorTools.hasErrorPatternOrMaxLength(this.controlName);
      this.stepperBuilderService.errorsEformBySection = this.stepperBuilderService.errorsEformBySection.filter(e=>e.path!==this.repeatablePathWithIndex);
      if(this.index && hasErrorPatternOrMaxLength){
        this.stepperBuilderService.errorsEformBySection.push({path: this.repeatablePathWithIndex, index: this.index})
      }
      return hasError;
    } else {
      const onSubmit = this.activeForm.controls[this._submitted]?.value;
      return FormInputErrorTools.hasError(this.activeForm, this.name, onSubmit);
    }
  }

  public unconvertDate(value) {
    if (this.type === 'date') {
      const DATE_PATTERN = '$3/$2/$1';
      const DATE_TIME_SEPERATOR = 'T';

      const ptrn = /(\d{4})-(\d{2})-(\d{2})/;
      const ptrn2 = /(\d{4})\/(\d{2})\/(\d{2})/;
      if (value && value.toString().match(ptrn)) {
        return value.split(DATE_TIME_SEPERATOR)[0].replace(ptrn, DATE_PATTERN);
      }
      if (value && value.toString().match(ptrn2)) {
        return value.split(DATE_TIME_SEPERATOR)[0].replace(ptrn2, DATE_PATTERN);
      }
    }

    return value;
  }
}
